module.exports = __webpack_public_path__ + "static/media/static-3.f1de8e89.jpg";